var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshLineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#FBEBE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.463 14.433A9.961 9.961 0 0 1 22 12c5.523 0 10 4.477 10 10 0 2.136-.67 4.116-1.81 5.74L27 22h3a8 8 0 0 0-13.54-5.772l-.997-1.795zm13.074 15.134A9.961 9.961 0 0 1 22 32c-5.523 0-10-4.477-10-10 0-2.136.67-4.116 1.81-5.74L17 22h-3a8 8 0 0 0 13.54 5.772l.997 1.795z",
    fill: "#FF5958"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 28a6 6 0 1 1 0-12 6 6 0 0 1 0 12zm.6-6v-3h-1.2v4.2H25V22h-2.4z",
    fill: "#FF5958"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshLineIcon);
export default __webpack_public_path__ + "static/media/refreshLineIcon.72dc89976c6658f662f1beaab034bcc8.svg";
export { ForwardRef as ReactComponent };